import { AxiosResponse } from 'axios';
import { call, put, select, StrictEffect, takeEvery } from 'redux-saga/effects';
import apiRoutes from 'config/apiRoute';
import api from 'utils/api';
import asyncErrorHandler from 'utils/asyncErrorHandler';
import { RootState } from 'store';
import { getProjectSelect, setProjectSelectData, setProjectSelectError, setProjectSelectLoading } from './projectSelect-slice';

const { get } = api;

function* getProjectSelectSagaListener() {
  const loading: boolean = yield select((store: RootState) => store.projectSelect.loading);

  if (loading) return;

  yield put(setProjectSelectLoading());

  try {
    const projectsRes: AxiosResponse = yield call(get, apiRoutes.PROJECTS_LITE, {
      'page[size]': 999,
      'filters[projects.status][]': 'active',
      with_personal: true,
    });

    let projectsData = projectsRes.data;

    if (projectsData && projectsData.data) {
      projectsData = projectsData.data;
    }

    const projectsList = projectsData.map((project: any) => ({
      ...project,
    }));

    const requestsRes: AxiosResponse = yield call(get, apiRoutes.REQUESTS, {
      'page[size]': 999,
      'filters[projects_requests.status]': ['new', 'waiting_approval', 'approved', 'needs_attention', 'in_progress'],
    });

    let requestsData = requestsRes.data;

    if (requestsData && requestsData.data) {
      requestsData = requestsData.data;
    }

    const requestsList = requestsData.map((request: any) => ({
      ...request,
    }));

    const projectsWithRequests = projectsList.map((project: any) => {
      const matchingRequests = requestsList.filter((request: any) => request.project && request.project.uuid === project.uuid);
      return {
        ...project,
        requests: matchingRequests,
      };
    });

    yield put(setProjectSelectData(projectsWithRequests));
  } catch (error) {
    yield put(setProjectSelectError(error));
    asyncErrorHandler(error);
  }
}

function* projectSelectSaga(): Generator<StrictEffect> {
  yield takeEvery(getProjectSelect.type, getProjectSelectSagaListener);
}

export default projectSelectSaga;
